export default __webpack_public_path__ + "static/media/ilias.8ac75595.png";